module.exports = __webpack_public_path__ + "media/images/pages/ai/icon-ethical-3cc4695e5aa5aa126fe8679d3a0cf866.svg";